import React, {useState, useEffect} from 'react';
import {bindActionCreators} from "redux";
import {sendAnotherCode} from "../../actions";
import {compose} from "../../utils";
import {connect} from "react-redux";
import SMS from "../../services/sms";

class CountDown extends React.Component {
    constructor() {
        super();

        this.state = {
            timer: 30,
        };

        this.interval = null;
        this.smsService = new SMS();
    }

    startCountDown = () => {
        this.interval = setInterval(() => {

            let newValue = this.state.timer - 1;

            this.setState({
                timer: newValue
            });

            if(newValue === 0) {
                clearInterval(this.interval);
            }
        }, 1000);
    };

    componentDidMount() {
        this.startCountDown();
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    onClickSendAnotherCodeHandler = () => {
        this.setState({
            timer: 30,
        });

        this.props.sendAnotherCode();
        this.startCountDown();
        this.smsService.sendAnotherCode(this.props.orderId);
    };

    render = () => {
        return (
            <>
                <div className="countdown">
               {/* <p className="modalType2__greyBox">
                    <span className="modalType2__greyBox--title">КОД ОТПРАВЛЕН.</span><br/>*/}
                    {this.state.timer > 0 &&
                        <span>Следующий можно отправить через {this.state.timer} секунд</span>
                    }
                    {this.state.timer === 0 &&
                    <a href="#" className="modalType2__greyBox--title" onClick={this.onClickSendAnotherCodeHandler}>Отправить
                        код
                        повторно</a>
                    }
                </div>
               {/* </p>*/}
            </>
        );
    }
};

const mapStateToProps = ({smsAttempt, orderId}) => {
    return {smsAttempt, orderId};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        sendAnotherCode,
    }, dispatch);
};


export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(CountDown);
